import { PropsWithChildren } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface RadioGroupLabelProps extends PropsWithChildren {
  className?: string;
}

/**
 * The item's label. Lays its children out in a row, so trailing content — a
 * badge, a count — is written inline after the text rather than passed in
 * through a prop.
 */
export function RadioGroupLabel({ className, children }: RadioGroupLabelProps) {
  return <span className={cn(css.label, className)}>{children}</span>;
}
